import { Reducer } from 'redux';

import { VoucherTypes, VoucherState } from './types';

const INITIAL_STATE: VoucherState = {
  voucher: null,
};

const reducer: Reducer<VoucherState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case VoucherTypes.TOGGLE_VOUCHER:
      return {
        ...state,
        voucher: action.payload.voucher,
      };

    default:
      return state;
  }
};

export default reducer;
